// Sample NFT data for Kanpai Pandas collection
export const cryptodickbuttsNFTs = [
  
 {
    id: 'cryptodickbutts-5343',
    name: 'CryptoDickbutts #5343',
    image: 'https://ipfs.io/ipfs/QmeSuPoYFmVMYVRL2j6fnUjBXif56pWpkhPhsMbuXHxTro',
    price: '1.75 ETH'
},
{
    id: 'cryptodickbutts-5351',
    name: 'CryptoDickbutts #5351',
    image: 'https://ipfs.io/ipfs/QmNcSmVaLrfyaL6zxKrUYyDqTMNtmKd1DcM8qFijyow8Ne',
    price: '2.1 ETH'
},
{
    id: 'cryptodickbutts-5355',
    name: 'CryptoDickbutts #5355',
    image: 'https://ipfs.io/ipfs/QmcJEqitWhhqy1KWLUSC31pknD6t1Z2f8Hzzxw65DRypcs',
    price: '1.2 ETH'
},
{
    id: 'cryptodickbutts-5354',
    name: 'CryptoDickbutts #5354',
    image: 'https://ipfs.io/ipfs/QmW7gT6qSKN6bKSUsFnfMsvJ2EKC8peqpreWz5A4gqnp46',
    price: '0.94 ETH'
},
{
    id: 'cryptodickbutts-5342',
    name: 'CryptoDickbutts #5342',
    image: 'https://ipfs.io/ipfs/QmW5DFPf3qG7qeJe6viu1y3rktMtPauQUHSXzcveLMHG1X',
    price: '1.85 ETH'
},
{
    id: 'cryptodickbutts-5353',
    name: 'CryptoDickbutts #5353',
    image: 'https://ipfs.io/ipfs/QmVJSWVqWMbN4EhhEpwh94NvtfTmmmXkybF3irfQvad3Fx',
    price: '2.2 ETH'
},
{
    id: 'cryptodickbutts-5350',
    name: 'CryptoDickbutts #5350',
    image: 'https://ipfs.io/ipfs/QmSsAtRRi9YZjb25Nuu3epJVAJ1U5DcTytwWFfX9nzwZuR',
    price: '1.45 ETH'
},
{
    id: 'cryptodickbutts-5341',
    name: 'CryptoDickbutts #5341',
    image: 'https://ipfs.io/ipfs/QmesVgB2BzD7Msf1ism3D9HfQ6H1am1JLLVMSdFYxVA6ZK',
    price: '1.95 ETH'
},
{
    id: 'cryptodickbutts-5352',
    name: 'CryptoDickbutts #5352',
    image: 'https://ipfs.io/ipfs/QmaeZYH7papbtKXsAWcrPrGY8wmnK6NZexMjhfsfVtAZFx',
    price: '1.15 ETH'
},
{
    id: 'cryptodickbutts-5347',
    name: 'CryptoDickbutts #5347',
    image: 'https://ipfs.io/ipfs/QmXiyYY5djSLpo1u6QvZrihbVd1GoZwTErxcRLzVYBwUDC',
    price: '1.65 ETH'
},
{
    id: 'cryptodickbutts-5346',
    name: 'CryptoDickbutts #5346',
    image: 'https://ipfs.io/ipfs/QmZEmMFCEzrQJ6mYVddNhsGCk9y1WAYPywXoUeqagKYuNw',
    price: '0.98 ETH'
},
{
    id: 'cryptodickbutts-5345',
    name: 'CryptoDickbutts #5345',
    image: 'https://ipfs.io/ipfs/QmNNHsUu64Rq7KArTbzsYoCjz2k8K473VebvuvKepasVnE',
    price: '1.85 ETH'
},
{
    id: 'cryptodickbutts-5340',
    name: 'CryptoDickbutts #5340',
    image: 'https://ipfs.io/ipfs/QmQ4U3qX6epNTv49PchsdXe7wEyp6FXZRoDLKDKyHDxunH',
    price: '2.15 ETH'
},
{
    id: 'cryptodickbutts-5349',
    name: 'CryptoDickbutts #5349',
    image: 'https://ipfs.io/ipfs/QmYQpW9dpVKLU492e73AhPjcX3AYGg9E8CFChf44xaVHqW',
    price: '1.35 ETH'
},
{
    id: 'cryptodickbutts-5344',
    name: 'CryptoDickbutts #5344',
    image: 'https://ipfs.io/ipfs/QmVYCvStX2UNGQwoabY8JtQ83b8uum2ai38UeG1nXLqBLh',
    price: '1.75 ETH'
},
{
    id: 'cryptodickbutts-5339',
    name: 'CryptoDickbutts #5339',
    image: 'https://ipfs.io/ipfs/QmexmqMQL8d7WSeryinjVwrW8mYZrjkNJC36indvqVPNpV',
    price: '0.94 ETH'
},
{
    id: 'cryptodickbutts-5348',
    name: 'CryptoDickbutts #5348',
    image: 'https://ipfs.io/ipfs/QmXZDaMQ4z1kFaXWbHCqVP6fShakCi21muCQqYY5fyQJcY',
    price: '2.1 ETH'
},
{
    id: 'cryptodickbutts-5338',
    name: 'CryptoDickbutts #5338',
    image: 'https://ipfs.io/ipfs/QmQ7ZHQGHe4CsY47LUfceVHGQhtzmWBz2h69UCk2xqcDPw',
    price: '1.55 ETH'
},
{
    id: 'cryptodickbutts-5337',
    name: 'CryptoDickbutts #5337',
    image: 'https://ipfs.io/ipfs/QmcDrfbqD8vx9i6FsPH3dG2LMHmYdJDg7WJYYd5tearYdW',
    price: '1.95 ETH'
},
{
    id: 'cryptodickbutts-5331',
    name: 'CryptoDickbutts #5331',
    image: 'https://ipfs.io/ipfs/QmRooAahbpKpMVWdBMV9zAHLvxiC7u2DytmVGWpNyUNw8p',
    price: '1.25 ETH'
},
{
    id: 'cryptodickbutts-5330',
    name: 'CryptoDickbutts #5330',
    image: 'https://ipfs.io/ipfs/QmU9hRE7Nn4BkY5PiyJyZ7zwFQT76ykaQcMz2iye5ko8qe',
    price: '1.85 ETH'
},
{
    id: 'cryptodickbutts-5336',
    name: 'CryptoDickbutts #5336',
    image: 'https://ipfs.io/ipfs/QmSYVAmyoWfbomaSSCH3RUZWRAnfxorXDUpdo7NYvd5H2x',
    price: '2.2 ETH'
},
{
    id: 'cryptodickbutts-5329',
    name: 'CryptoDickbutts #5329',
    image: 'https://ipfs.io/ipfs/QmYeTi4h9itx353gkyspmEBqEJnn8AaazbTMEahux2LQyE',
    price: '1.45 ETH'
},
{
    id: 'cryptodickbutts-5335',
    name: 'CryptoDickbutts #5335',
    image: 'https://ipfs.io/ipfs/QmepJd6ktM2a4TS8itizCipCKcpx6zA6oS6SnaGpkRhTpz',
    price: '0.94 ETH'
},
{
    id: 'cryptodickbutts-5328',
    name: 'CryptoDickbutts #5328',
    image: 'https://ipfs.io/ipfs/QmVNyzU6y2apRFwkY4xJFx1dRSTsRmLtHdEPPLd8s8T2Lf',
    price: '1.75 ETH'
},
{
    id: 'cryptodickbutts-5327',
    name: 'CryptoDickbutts #5327',
    image: 'https://ipfs.io/ipfs/QmbHoBeL2FcxREGacJiupeffF1FqxkoeZh3rsxu3NcxSwQ',
    price: '2.1 ETH'
},
{
    id: 'cryptodickbutts-5334',
    name: 'CryptoDickbutts #5334',
    image: 'https://ipfs.io/ipfs/QmdHP7tD6yugvGp4AkVNEhWCbtpMsNHgM5UmYqm6upERSh',
    price: '1.35 ETH'
},
{
    id: 'cryptodickbutts-5333',
    name: 'CryptoDickbutts #5333',
    image: 'https://ipfs.io/ipfs/QmbsDj39VRMiVesoXJp3eYnUUngvKspCyq4XQFiJXB2jJC',
    price: '1.95 ETH'
},
{
    id: 'cryptodickbutts-5326',
    name: 'CryptoDickbutts #5326',
    image: 'https://ipfs.io/ipfs/QmbfiAyBZeyCuw5xR3hsX22DeRdqvbC6PRBkSokUCBzCoH',
    price: '1.15 ETH'
},
{
    id: 'cryptodickbutts-5325',
    name: 'CryptoDickbutts #5325',
    image: 'https://ipfs.io/ipfs/QmTrD8pseG5PUHRiC5ztHhi2ofR7paeTdmdkdTXwxF7rCc',
    price: '1.85 ETH'
},
{
    id: 'cryptodickbutts-5324',
    name: 'CryptoDickbutts #5324',
    image: 'https://ipfs.io/ipfs/Qmas4g6FqLr3DxCumceuZRcLAj7cc4CKLGodfVLcR96ooV',
    price: '2.2 ETH'
},
{
    id: 'cryptodickbutts-5319',
    name: 'CryptoDickbutts #5319',
    image: 'https://ipfs.io/ipfs/QmZParoVPMWVWA4Gw2yGzcGJ4gbG7uAMjHMck8dHNHeVU9',
    price: '1.45 ETH'
},
{
    id: 'cryptodickbutts-5323',
    name: 'CryptoDickbutts #5323',
    image: 'https://ipfs.io/ipfs/Qmc4xEG9jMiY6DCei5ocbeHqd63Tn22vE1m9FbWkDdjCsz',
    price: '0.94 ETH'
},
{
    id: 'cryptodickbutts-5318',
    name: 'CryptoDickbutts #5318',
    image: 'https://ipfs.io/ipfs/QmV9JUUi62ufzcb3PH57WGiHqJWED7RpUEGpAus1YudB3r',
    price: '1.75 ETH'
},
{
    id: 'cryptodickbutts-5332',
    name: 'CryptoDickbutts #5332',
    image: 'https://ipfs.io/ipfs/QmbDnMHJNN5LCWnumUFqV89M5geRiMKNCGBX8Mec2s7q5A',
    price: '2.1 ETH'
},
{
    id: 'cryptodickbutts-5321',
    name: 'CryptoDickbutts #5321',
    image: 'https://ipfs.io/ipfs/QmPWwbFxxopvTFV6P6AtWFhkKM95Wdb8Rs7aDJSon9CzpL',
    price: '1.35 ETH'
},
{
    id: 'cryptodickbutts-5317',
    name: 'CryptoDickbutts #5317',
    image: 'https://ipfs.io/ipfs/QmPtit3RyAfeXtWfM2gJE154JX8A9bFvTorE2H3Q5Qa2Ww',
    price: '1.95 ETH'
},
{
    id: 'cryptodickbutts-5322',
    name: 'CryptoDickbutts #5322',
    image: 'https://ipfs.io/ipfs/QmcZTgHvyfQbBGF6UoKLTd5s1N7EnoYYdWgAfWqDn6fUeV',
    price: '1.15 ETH'
},
{
    id: 'cryptodickbutts-5316',
    name: 'CryptoDickbutts #5316',
    image: 'https://ipfs.io/ipfs/QmeM9sANMYxCN8EMXyNdZuvgcUXTP24eBhE7wd5XHw4YpX',
    price: '2.2 ETH'
},
    {
    id: 'cryptodickbutts-5360',
    name: 'CryptoDickbutts #5360',
    image: 'https://ipfs.io/ipfs/QmNrQhmDZwKB2YzdeWBESzAowmQre4mqrPKsUCWgMrsXGD',
    price: '1.85 ETH'
},
{
    id: 'cryptodickbutts-5359',
    name: 'CryptoDickbutts #5359',
    image: 'https://ipfs.io/ipfs/QmZePmEAajcUPcxUkoQ2qVmx8grD659q9rjevCMUsHyZoz',
    price: '0.94 ETH'
},
{
    id: 'cryptodickbutts-5358',
    name: 'CryptoDickbutts #5358',
    image: 'https://ipfs.io/ipfs/QmTbpoS4CzEmRmpEtefyexikodxLKxA4oCSozqKskfpWA7',
    price: '2.1 ETH'
},
{
    id: 'cryptodickbutts-5357',
    name: 'CryptoDickbutts #5357',
    image: 'https://ipfs.io/ipfs/QmNuQG6GuXE1dbUu95mEqQMJcxTLTX5KsaKThbMoe1Rt2A',
    price: '1.45 ETH'
},
{
    id: 'cryptodickbutts-5356',
    name: 'CryptoDickbutts #5356',
    image: 'https://ipfs.io/ipfs/QmUn7XwxMcnoinBSyzdqfAQAPeGm2FRByLFGuZM82kyK9W',
    price: '2.2 ETH'
},
    {
    id: 'cryptodickbutts-5301',
    name: 'CryptoDickbutts #5301',
    image: 'https://ipfs.io/ipfs/QmSiBg7iezs4tqvV86q5hW1TDgLAu32Rei2qyYvpNMuX9Z',
    price: '1.85 ETH'
},
{
    id: 'cryptodickbutts-5300',
    name: 'CryptoDickbutts #5300',
    image: 'https://ipfs.io/ipfs/QmXDv1vy88TBVEMew5kRwFW88sZ4FHWwKe3C2qhbbZuex3',
    price: '2.1 ETH'
},
{
    id: 'cryptodickbutts-5299',
    name: 'CryptoDickbutts #5299',
    image: 'https://ipfs.io/ipfs/QmVPEDnrYyYL6a14vmhNXPZCZS72Uihf19Lb3aBUb99tKp',
    price: '1.45 ETH'
},
{
    id: 'cryptodickbutts-5298',
    name: 'CryptoDickbutts #5298',
    image: 'https://ipfs.io/ipfs/QmUbjYG6r8gCqmBtBdiLxPo4A51mX11NNtXfYMDwYUunbr',
    price: '0.94 ETH'
},
{
    id: 'cryptodickbutts-5293',
    name: 'CryptoDickbutts #5293',
    image: 'https://ipfs.io/ipfs/QmdrYWRFQn7CrjcBfGUhQdFm4wk6DRxoxLQaZfmvQHgi3d',
    price: '1.65 ETH'
},
{
    id: 'cryptodickbutts-5297',
    name: 'CryptoDickbutts #5297',
    image: 'https://ipfs.io/ipfs/QmVcyyHsisYXBnaQbGese1ZzJEqiVbJiNdfQYCTA5brfVj',
    price: '2.2 ETH'
},
{
    id: 'cryptodickbutts-5296',
    name: 'CryptoDickbutts #5296',
    image: 'https://ipfs.io/ipfs/QmcXAiEjwcNZc4d7sGvHVxuuY8LHRo5qytoUaVd22R2ifY',
    price: '1.35 ETH'
},
{
    id: 'cryptodickbutts-5290',
    name: 'CryptoDickbutts #5290',
    image: 'https://ipfs.io/ipfs/QmSqaohMMij8KAQrAt5q8nzjrtJ6Lt6XeB91UXcmNB4fkz',
    price: '1.95 ETH'
},
{
    id: 'cryptodickbutts-5289',
    name: 'CryptoDickbutts #5289',
    image: 'https://ipfs.io/ipfs/Qmeo9DD3YL9kyJ9PJMJzpg7vjR7D62CK7rxW43EoW2RKHx',
    price: '1.15 ETH'
},
{
    id: 'cryptodickbutts-5292',
    name: 'CryptoDickbutts #5292',
    image: 'https://ipfs.io/ipfs/QmZmziHG5iGC5r7PxNVpNqgceXhH42gbLqbC6kacp4Cpr9',
    price: '1.75 ETH'
},
{
    id: 'cryptodickbutts-5291',
    name: 'CryptoDickbutts #5291',
    image: 'https://ipfs.io/ipfs/QmPh31XuYzXMizBrZesFv8L5wYeD8UCqeVXQe5Y37jigyf',
    price: '2.1 ETH'
},
{
    id: 'cryptodickbutts-5288',
    name: 'CryptoDickbutts #5288',
    image: 'https://ipfs.io/ipfs/QmfD51SatuHhzV1H7gmXkq61fuWs6UqV3Mq3WNsLSJ4WKQ',
    price: '1.45 ETH'
},
{
    id: 'cryptodickbutts-5287',
    name: 'CryptoDickbutts #5287',
    image: 'https://ipfs.io/ipfs/QmXbnMpsWwcQZk8PZTTiumwpmSUU1fXbHrBhBzj7r4xjGh',
    price: '0.98 ETH'
},
{
    id: 'cryptodickbutts-5286',
    name: 'CryptoDickbutts #5286',
    image: 'https://ipfs.io/ipfs/QmWwMiUxbv3W2Xs7CLgi3Gn2KcUyjVNsHCcsL43Y34ASC9',
    price: '1.85 ETH'
},
{
    id: 'cryptodickbutts-5285',
    name: 'CryptoDickbutts #5285',
    image: 'https://ipfs.io/ipfs/QmQT2KMhoo6L1Q1o3dR5prjaymT7CyuE77ZoK1K8K3xqu5',
    price: '2.2 ETH'
},
{
    id: 'cryptodickbutts-5284',
    name: 'CryptoDickbutts #5284',
    image: 'https://ipfs.io/ipfs/QmPcL667aGXJqjnNTJkStKkFUbpwRPt5Xt9FMoBemfTWbk',
    price: '1.35 ETH'
},
{
    id: 'cryptodickbutts-5283',
    name: 'CryptoDickbutts #5283',
    image: 'https://ipfs.io/ipfs/QmTc9v3qW8LCSCW7U7TpzpWfVv4E3yKGe1HAiiM4NEmhZv',
    price: '1.95 ETH'
},
{
    id: 'cryptodickbutts-5282',
    name: 'CryptoDickbutts #5282',
    image: 'https://ipfs.io/ipfs/QmQwYo1M8XTcfLy17zztm7fWZYuGYrS5rZUL8EWPiSFXpB',
    price: '1.15 ETH'
},
{
    id: 'cryptodickbutts-5281',
    name: 'CryptoDickbutts #5281',
    image: 'https://ipfs.io/ipfs/QmPSdUkFRBX9QcyuZafQiz7PFUDdub1c7VHgQDvUj1Bfgp',
    price: '1.75 ETH'
},
{
    id: 'cryptodickbutts-5280',
    name: 'CryptoDickbutts #5280',
    image: 'https://ipfs.io/ipfs/Qmb5hugUwSvxT61FvwqRr9WWpE9BgM24LFAdvVFPBjMcAh',
    price: '2.1 ETH'
},
{
    id: 'cryptodickbutts-5279',
    name: 'CryptoDickbutts #5279',
    image: 'https://ipfs.io/ipfs/QmRsM6NqhPjknzbLqkkB1NupJBHuXCwHzf7YJANLRBqDHH',
    price: '1.45 ETH'
},
{
    id: 'cryptodickbutts-5278',
    name: 'CryptoDickbutts #5278',
    image: 'https://ipfs.io/ipfs/QmSmx656X5y1HVqCYhKJpuaLrHbgtEcfUW6RwkhfBh8STc',
    price: '0.94 ETH'
},
{
    id: 'cryptodickbutts-5277',
    name: 'CryptoDickbutts #5277',
    image: 'https://ipfs.io/ipfs/QmQk3d38DjGAkErbmA37p59xU8dps5E2Z1oNbg8KN9fdrs',
    price: '1.85 ETH'
},
{
    id: 'cryptodickbutts-5276',
    name: 'CryptoDickbutts #5276',
    image: 'https://ipfs.io/ipfs/QmZkCqXHHrw31m2jmfcrbHk7KFyNcBD9gbZ7SFLhiKRC8w',
    price: '2.2 ETH'
},
{
    id: 'cryptodickbutts-5275',
    name: 'CryptoDickbutts #5275',
    image: 'https://ipfs.io/ipfs/QmNsaTdxe2gy5WvrEaKpVX5agbX1DsBdgqFpAaSpzQVLZw',
    price: '1.35 ETH'
},
{
    id: 'cryptodickbutts-5274',
    name: 'CryptoDickbutts #5274',
    image: 'https://ipfs.io/ipfs/QmXYG4KavtbXKtmSWbvuiXhJSFT3rRCkL2wkUG7Bmb8T7v',
    price: '1.95 ETH'
},
{
    id: 'cryptodickbutts-5273',
    name: 'CryptoDickbutts #5273',
    image: 'https://ipfs.io/ipfs/QmeKLgbSKTiHBQrBkpD8eYtwWDQDEfr36YuW9ooGRBLMRD',
    price: '1.15 ETH'
},
{
    id: 'cryptodickbutts-5272',
    name: 'CryptoDickbutts #5272',
    image: 'https://ipfs.io/ipfs/QmVpmZMiY5rAieUeBXrsaFh2xpNJR4Z1qiBoDzExe9Qbdu',
    price: '1.75 ETH'
},
{
    id: 'cryptodickbutts-5271',
    name: 'CryptoDickbutts #5271',
    image: 'https://ipfs.io/ipfs/Qma7jMhAB8tfh95qiemRNpq9cDS36X8drfbXRktMUSVzMz',
    price: '2.1 ETH'
},
{
    id: 'cryptodickbutts-5270',
    name: 'CryptoDickbutts #5270',
    image: 'https://ipfs.io/ipfs/QmP7o3w9W7Ru4P3NWrvao4jfdaFvMhtNnHDuDQeeMp8CVw',
    price: '1.45 ETH'
},
{
    id: 'cryptodickbutts-5269',
    name: 'CryptoDickbutts #5269',
    image: 'https://ipfs.io/ipfs/QmXoPKfLuoDKkB6VjcS1gEpXD2SQDpeAa6M3ooDZjV2en3',
    price: '0.94 ETH'
},
{
    id: 'cryptodickbutts-5268',
    name: 'CryptoDickbutts #5268',
    image: 'https://ipfs.io/ipfs/QmTfznaEukA3Nk77umGfvp6iXAWp6d9wFXSmUp8tGtbYDR',
    price: '1.85 ETH'
},
{
    id: 'cryptodickbutts-5267',
    name: 'CryptoDickbutts #5267',
    image: 'https://ipfs.io/ipfs/QmfJv6Cd3oFucj3f2qwGmNU21EQYq9XAT2FqM3aV4sinrC',
    price: '2.2 ETH'
},
{
    id: 'cryptodickbutts-5266',
    name: 'CryptoDickbutts #5266',
    image: 'https://ipfs.io/ipfs/QmcDGpb1NKdpmr4j2zxVAzA4pZ5wfByifGXwKK2yrgkwKD',
    price: '1.35 ETH'
},
{
    id: 'cryptodickbutts-5265',
    name: 'CryptoDickbutts #5265',
    image: 'https://ipfs.io/ipfs/QmcBpDXs26654AfLCFN7aV9CMZ5TUuvXKtxb22VPKn4AU4',
    price: '1.95 ETH'
},
{
    id: 'cryptodickbutts-5264',
    name: 'CryptoDickbutts #5264',
    image: 'https://ipfs.io/ipfs/QmdHFanm2StaiU5gBX1hUTbmW3hMGq9z8wLXFKNKMdWWMV',
    price: '1.15 ETH'
},
{
    id: 'cryptodickbutts-5263',
    name: 'CryptoDickbutts #5263',
    image: 'https://ipfs.io/ipfs/QmfMWTY8iMZDF7JYNNgviooc65EpfSR4s3LoemwUqRahmY',
    price: '1.75 ETH'
},
{
    id: 'cryptodickbutts-5262',
    name: 'CryptoDickbutts #5262',
    image: 'https://ipfs.io/ipfs/QmRndFJwDnctk3kB3uPJEGofBNnXVpR5XncHGeLth4myhq',
    price: '2.1 ETH'
},
{
    id: 'cryptodickbutts-5261',
    name: 'CryptoDickbutts #5261',
    image: 'https://ipfs.io/ipfs/QmY1i4sFqAbKM4YH71SfMga4ooNvjTkifmDLNjhhL5rRmt',
    price: '1.45 ETH'
}
    
];
